import React from 'react';

import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Skeleton } from 'uikit/loaders';

import styles from '../styles/uikitCardsCardSkeleton.module.scss';

const CardSkeleton = ({ variant = 'grid' }) => {
  const CLASSES = {
    variant: {
      grid: styles.isVariantGrid,
      list: styles.isVariantList,
      embed: styles.isVariantEmbed,
    },
  };

  let imageHeight = 144;
  if (variant === 'list') {
    imageHeight = 90;
  } else if (variant === 'embed') {
    imageHeight = 56;
  }

  return (
    <div className={styles.element}>
      <div className={classnames({ [CLASSES.variant[variant]]: variant })}>
        <Skeleton className={styles.loaderImage} height={imageHeight} />
        <div className={styles.content}>
          <div className={styles.title}>
            <Skeleton
              className={styles.loaderText}
              height={variant === 'embed' ? 14 : 18}
              width={variant === 'grid' || variant === 'embed' ? 200 : 400}
              count={variant === 'grid' || variant === 'embed' ? 2 : 1}
            />
          </div>
          {(variant === 'list' || variant === 'embed') && (
            <div className={styles.description}>
              {variant === 'list' && (
                <>
                  <Skeleton className={styles.loaderText} height={14} />
                  <Skeleton className={styles.loaderText} height={14} width={300} />
                </>
              )}
              <div className={styles.meta}>
                <Skeleton className={styles.loaderText} height={12} width={100} />
              </div>
            </div>
          )}
          {variant === 'grid' && (
            <div className={styles.meta}>
              <Skeleton className={styles.loaderText} height={12} width={100} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

CardSkeleton.propTypes = {
  variant: PropTypes.oneOf(['embed', 'grid', 'list']),
};

export default CardSkeleton;
